var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWedge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 1000 100",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wedge_svg__elementor-shape-fill",
    d: "M0 6V0h1000v100L0 6z"
  })));
}

export default SvgWedge;